let language = {
    "LBL_HOME":"Home",
    "LBL_ADMIN":"Admin",
   "LBL_USER_ADD_DASHLET":"New User Default Dashlet",
   "LBL_USER_VIEW_DASHLET":"View User Default Dashlets",
   "LBL_DASHLET_NAME":"Dashlet Name",
   "LBL_USER_TYPE":"User Type",
   "LBL_MODULE_DASHLETS":"Module Dashlets",
   "LBL_DASHLET_TYPE":"Dashlet Type",
   "LBL_DASHLET_GRAPH":"Graph",
   "LBL_DASHLET_TABLE":"Table",
   "LBL_GRAPH_TYPE":"Graph Type",
   "LBL_Title":"Title",
   "LBL_CREATED_BY": "Created By",
   "LBL_PARENT_ID": "Parent ID",
   "LBL_PARENT_TYPE": "Parent Type",
   "LBL_DESCRIPTION":"Description",
   "LBL_CREATE_DATE":"Date Created",
   "LBL_ENTERED":"Date Entered",
   "LBL_MODIFIED_DATE":"Date Modified",
   "LBL_DOWNLOAD_ONE":"Download 1",
   "LBL_DOWNLOAD_TWO":"Download 2",
   "LBL_EDIT":"Edit",
   "LBL_DELETE":"Delete",
   "LBL_NAME":"Name",
   "LBL_USER_TYPE":"User Type",
}

export default language;